const HisMapMarker = ({ color, sx }) => {
  const strokeColor = color ?? "#708FBB";
  const _sx = sx ?? {};
  return (
    <svg
      style={_sx}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20 9.67075C20 15.4732 12 21.2757 12 21.2757C12 21.2757 4 15.4732 4 9.67075C4 7.61886 4.84285 5.65101 6.34315 4.2001C7.84344 2.74919 9.87827 1.93408 12 1.93408C14.1217 1.93408 16.1566 2.74919 17.6569 4.2001C19.1571 5.65101 20 7.61886 20 9.67075Z"
        stroke={strokeColor}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 12.572C13.6569 12.572 15 11.2731 15 9.67078C15 8.06846 13.6569 6.76953 12 6.76953C10.3431 6.76953 9 8.06846 9 9.67078C9 11.2731 10.3431 12.572 12 12.572Z"
        stroke={strokeColor}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default HisMapMarker;
